// Migrated
<template>
  <ScreenWidthProvider
    v-if="lat && lng"
    v-slot="{ isWider }"
    class="destination-map"
  >
    <div
      class="map-container w-full cursor-zoom-in"
      @click="openModal"
    >
      <MapboxPreview
        class="size-full"
        :center="coordinates"
        :zoom="zoom"
        :markers="[coordinates]"
      />
    </div>
    <div class="w-full px-6 py-4 flex flex-col md:flex-row justify-between items-center bg-dark-blue text-white">
      <LocationText
        class="order-2 md:order-1"
        v-bind="location"
        :show-icon="isWider('md')"
      />
      <h5 class="destination-map-hotel-here-text text-white order-1 md:order-2 mb-2 md:mb-0">
        <i-twisted-arrow-right-to-top-icon
          class="-mt-3 mr-2"
          height="18px"
          filled
          :font-controlled="false"
        />
        <span
          class="font-fancy"
          data-i18n="hotelLocatedHere"
        >{{ $t('hotelLocatedHere') }}</span>
      </h5>
    </div>
    <LazyMapModal
      v-if="modalVisible"
      :coordinates="coordinates"
      :visible="modalVisible"
      :zoom="zoom"
      @on-hide="hideModal"
    />
  </ScreenWidthProvider>
</template>

<script>
export default defineNuxtComponent({
  props: {
    lat: {
      type: Number,
      default: null,
    },

    lng: {
      type: Number,
      default: null,
    },

    /**
     * @prop {
     *   destination: string
     *   postcode: string
     *   locality: string
     *   city: string
     *   country: string
     * } location
     */
    location: {
      type: Object,
      default: () => ({}),
    },

    allowFullscreen: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      modalVisible: false,
      zoom: 12,
    }
  },

  computed: {
    coordinates () {
      return [this.lng, this.lat]
    },
  },

  methods: {
    openModal () {
      this.modalVisible = true
    },

    hideModal () {
      this.modalVisible = false
    },
  },
})
</script>

<style lang="scss">
.destination-map {
  .map-container {
    height: 260px;
  }

  &-hotel-here-text {
    span {
      font-size: 1.15rem;
      font-weight: normal;
      letter-spacing: 1px;

      @media (max-width: theme('screens.md')) {
        font-size: 1.1rem;
      }
    }

    svg {
      transform: scaleX(-1);
    }
  }
}
</style>
